import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

/**
 * Legacy redirect for password-reset emails sent BEFORE the fragment
 * switch. Old links look like /reset-password/<token>. We translate
 * them in the client to /reset-password#token=<hex>.
 *
 * IMPORTANT — load-bearing rules for this file:
 *
 *   1. Do NOT add any API call, analytics ping, or token introspection
 *      before history.replace below. Any outbound HTTP request from
 *      this URL would include the path-form token in the Referer
 *      header, exactly the leak we are closing.
 *
 *   2. Do NOT render the token into the DOM. The component renders
 *      null so a screenshot/inspector cannot harvest it.
 *
 *   3. Use history.replace (NOT history.push) so the leaky URL is
 *      removed from the back-button stack.
 *
 *   4. Delete this entire file + the matching route in routes/index.js
 *      ~1h after the prod deploy that ships fragment-based emails. All
 *      in-flight pre-deploy tokens will have expired by then (1h TTL).
 */
export default function ResetPasswordLegacyRedirect() {
	const history = useHistory();
	const { token } = useParams();

	useEffect(() => {
		const safeToken = String(token || "");
		// history.replace performs a pushState-style navigation, which
		// updates window.location WITHOUT a network round-trip — so the
		// token is rewritten purely client-side and never reaches the
		// server in the Referer header.
		history.replace({
			pathname: "/reset-password",
			hash: `#token=${encodeURIComponent(safeToken)}`,
		});
	}, [history, token]);

	return null;
}
